import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextInput } from '@any-ui-react/core';

import {
  LineMessageBlockType,
  DEFAULT_BUTTON_TYPE_BLOCK,
  DEFAULT_BUTTON_TYPE_BLOCK_CARD,
  DEFAULT_IMAGE_TYPE_BLOCK_CARD,
  LineMessageForm,
} from '../../../components';
import { useLineMessageDialogStore } from '../store';
import { LineMessageDialogFormFields } from '../types';

const appendBlockByType = (type: LineMessageBlockType) => {
  if (type === 'BUTTON') {
    return {
      ...DEFAULT_BUTTON_TYPE_BLOCK,
      cards: [DEFAULT_BUTTON_TYPE_BLOCK_CARD],
    };
  }

  if (type === 'IMAGES') {
    return {
      type: LineMessageBlockType.enum.IMAGES,
      cards: [DEFAULT_IMAGE_TYPE_BLOCK_CARD],
    };
  }

  return;
};

export const DefaultView = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<LineMessageDialogFormFields>();

  const isFormDisabled = useLineMessageDialogStore((state) => state.isFormDisabled);
  const { t } = useTranslation('crm');

  return (
    <div>
      <TextInput
        {...register('title')}
        required
        readOnly={isFormDisabled}
        label={t('crm.lineMessageDialogForm.fields.title.label')}
        placeholder={t('crm.lineMessageDialogForm.fields.title.placeholder')}
        error={errors.title?.message}
      />
      <p className="text-gray-7 text-3xs mt-1 whitespace-pre-wrap">
        {t('crm.lineMessageDialogForm.fields.title.helperText')}
      </p>
      <LineMessageForm.MessageBlocks appendBlockByType={appendBlockByType} />
    </div>
  );
};
